/* ============================================================
   The Chimney Cake — Custom scripts
   IntersectionObserver, nav scroll, ember canvas, mobile nav,
   product carousel.
   ============================================================ */

/* In Shopify theme editor — make all reveal elements immediately visible */
if (window.Shopify && window.Shopify.designMode) {
  document.documentElement.classList.add('cc-design-mode');
}
document.addEventListener('shopify:section:load', function () {
  document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
    el.classList.add('is-visible');
  });
});

function ccInit() {

  /* ── Scroll-reveal — skip in theme editor ── */
  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ── Nav scroll state ──
     Desktop: Horizon scrolls .page-wrapper (not window) → use IntersectionObserver on hero
     Mobile:  window scrolls → use scroll listener on window + page-wrapper as fallback */
  var nav = document.querySelector('.cc-nav');
  if (nav && !nav.classList.contains('cc-nav--solid')) {
    var hero = document.querySelector('.cc-hero');

    function setScrolled(yes) { nav.classList.toggle('scrolled', yes); }

    var darkHero = document.querySelector('.cc-menu-pg-head, .cc-shop-prev-hero, [data-dark-hero]');
    if (!hero && !darkHero) setScrolled(true);

    /* Mobile: window scroll */
    window.addEventListener('scroll', function () {
      setScrolled(window.scrollY > 60);
    }, { passive: true });

    /* Desktop: Horizon scrolls .page-wrapper, not window */
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', function () {
      setScrolled(pw.scrollTop > 60);
    }, { passive: true });
  }

  /* ── Mobile nav ── */
  var burger  = document.getElementById('cc-nav-burger');
  var mobNav  = document.getElementById('cc-mob-nav');
  var closeBtn = document.getElementById('cc-mob-nav-close');

  if (burger && mobNav) {
    function openMenu() {
      mobNav.style.display = 'flex';
      requestAnimationFrame(function () { mobNav.classList.add('is-open'); });
      burger.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobNav.classList.remove('is-open');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { mobNav.style.display = 'none'; }, 350);
    }

    burger.addEventListener('click', function () {
      burger.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ── Product carousel (Spotlight section) ── */
  var canItems  = document.querySelectorAll('.cc-can-item');
  var panels    = document.querySelectorAll('.cc-product-panel');
  var switchBtns = document.querySelectorAll('.cc-can-switch-btn');

  if (canItems.length) {
    var activeIdx = 0;
    var positions = ['active', 'right', 'left'];

    function getPos(itemIndex, activeIndex) {
      return positions[(itemIndex - activeIndex + 3) % 3];
    }

    function goTo(newActive) {
      if (newActive === activeIdx) return;
      activeIdx = newActive;

      canItems.forEach(function (item, i) {
        item.classList.remove('active', 'left', 'right');
        item.classList.add(getPos(i, activeIdx));
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('active', i === activeIdx);
      });
      switchBtns.forEach(function (b, i) {
        b.classList.toggle('active', i === activeIdx);
      });
    }

    canItems.forEach(function (item, i) {
      item.addEventListener('click', function () { goTo(i); });
    });
    switchBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i); });
    });
  }

  /* ── Ember canvas ── */
  var canvas = document.getElementById('cc-ember-canvas');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    var W, H, particles = [];

    function resize() {
      W = canvas.width  = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    function rand(a, b) { return a + Math.random() * (b - a); }

    function spawn() {
      return {
        x: rand(0.1, 0.9) * W,
        y: H * rand(0.6, 1.0),
        vx: rand(-0.6, 0.6),
        vy: rand(-1.8, -0.8),
        life: 0,
        maxLife: rand(80, 160),
        r: rand(1, 2.5),
        hue: Math.random() > 0.5 ? 35 : 45
      };
    }

    for (var i = 0; i < 18; i++) {
      var p = spawn();
      p.life = rand(0, p.maxLife);
      particles.push(p);
    }

    var heroBottom = window.innerHeight;

    function getHeroBottom() {
      var hero = document.querySelector('.cc-hero');
      if (hero) heroBottom = hero.getBoundingClientRect().bottom;
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      getHeroBottom();
      if (window.scrollY > heroBottom + 100) {
        requestAnimationFrame(draw);
        return;
      }
      particles.forEach(function (p, idx) {
        p.life++;
        if (p.life > p.maxLife) { particles[idx] = spawn(); return; }
        p.x += p.vx + Math.sin(p.life * 0.05) * 0.4;
        p.y += p.vy;
        var alpha = Math.sin((p.life / p.maxLife) * Math.PI) * 0.85;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'hsla(' + p.hue + ', 85%, 60%, ' + alpha + ')';
        ctx.fill();
      });
      requestAnimationFrame(draw);
    }

    draw();
  }

  /* ── Progress line (Our Story) ──
     Replicates design/our-story.html. Adapted for Horizon: on desktop the
     scroll container is .page-wrapper, not window. Line is hidden < 960px. */
  var progLine = document.getElementById('cc-progress-line');
  if (progLine) {
    var fill    = document.getElementById('cc-progress-fill');
    var diamond = document.getElementById('cc-progress-diamond');
    var chapters = ['ch1', 'ch2', 'ch3', 'ch4', 'ch5', 'ch6'];

    /* Pick the actual scroll container: Horizon scrolls .page-wrapper on
       desktop; fall back to window if it isn't the scroller. */
    var pwEl = document.querySelector('.page-wrapper');
    function getScroller() {
      if (pwEl && pwEl.scrollHeight > pwEl.clientHeight + 4) return pwEl;
      return window;
    }

    function scrollTopOf(sc) { return sc === window ? window.scrollY : sc.scrollTop; }
    function maxScrollOf(sc) {
      return sc === window
        ? document.documentElement.scrollHeight - window.innerHeight
        : sc.scrollHeight - sc.clientHeight;
    }
    /* Offset of an element within the scroller's scrollable content. */
    function offsetInScroller(el, sc) {
      var top = scrollTopOf(sc);
      var scTop = sc === window ? 0 : sc.getBoundingClientRect().top;
      return el.getBoundingClientRect().top - scTop + top;
    }

    function positionAnchors() {
      var sc = getScroller();
      var max = maxScrollOf(sc) || 1;
      chapters.forEach(function (id) {
        var el = document.getElementById('cc-' + id);
        var anchor = document.getElementById('cc-anchor-' + id);
        if (!anchor) return;
        if (!el) { anchor.style.display = 'none'; return; }
        var pct = (offsetInScroller(el, sc) / max) * 100;
        anchor.style.top = pct + '%';
        anchor.style.marginTop = '-4px';
      });
    }

    function updateProgress() {
      var sc = getScroller();
      var max = maxScrollOf(sc) || 1;
      var top = scrollTopOf(sc);
      var pct = Math.max(0, Math.min(100, (top / max) * 100));
      if (fill) fill.style.height = pct + '%';
      if (diamond) diamond.style.top = 'calc(' + pct + '% - 4px)';
      chapters.forEach(function (id) {
        var el = document.getElementById('cc-' + id);
        var anchor = document.getElementById('cc-anchor-' + id);
        if (!el || !anchor) return;
        anchor.classList.toggle('passed', top >= offsetInScroller(el, sc) - 80);
      });
    }

    /* Listen on both possible scrollers so it works regardless of which one
       is active (desktop page-wrapper / any window-scroll fallback). */
    if (pwEl) pwEl.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', function () { positionAnchors(); updateProgress(); }, { passive: true });

    positionAnchors();
    updateProgress();
    /* Re-measure once fonts/images settle. */
    window.addEventListener('load', function () { positionAnchors(); updateProgress(); });
    setTimeout(function () { positionAnchors(); updateProgress(); }, 600);
  }

}

/* ── Cart drawer — open/close with backdrop ── */
(function() {
  function getDrawer() { return document.querySelector('theme-drawer#cart-drawer'); }
  function getBackdrop() { return document.getElementById('cc-cart-backdrop'); }

  function isOpen() {
    var d = getDrawer();
    return d && d.isOpen;
  }

  function showBackdrop() {
    var b = getBackdrop();
    if (b) b.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function hideBackdrop() {
    var b = getBackdrop();
    if (b) b.classList.remove('active');
    document.body.style.overflow = '';
  }

  function ccClose() {
    var d = getDrawer();
    if (d && d.close) d.close();
    hideBackdrop();
  }

  window.ccOpenCartDrawer = function() {
    var d = getDrawer();
    if (!d) return;
    d.open();
    showBackdrop();
  };

  /* Watch for Horizon closing the drawer (X button, etc) — sync backdrop */
  function initWatcher() {
    var d = getDrawer();
    var dialog = d ? d.querySelector('dialog') : null;
    if (!dialog) return;

    new MutationObserver(function() {
      if (dialog.open) showBackdrop();
      else hideBackdrop();
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  /* Backdrop click and Escape */
  document.addEventListener('click', function(e) {
    if (e.target.id === 'cc-cart-backdrop') ccClose();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen()) ccClose();
  });

  /* Init on load */
  function init() { initWatcher(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Product card enhancements — type label, ornament, add ring ── */
function ccInjectProductType() {
  document.querySelectorAll('product-card').forEach(function(card) {
    if (card.dataset.ccTypeDone) return;
    card.dataset.ccTypeDone = '1';
    var link = card.querySelector('.product-card__link');
    var titleBlock = card.querySelector('.text-block');
    if (!link || !titleBlock) return;
    /* Hide Horizon zoom-out duplicate title */
    var zoomOut = card.querySelector('[class*="zoom-out"]');
    if (zoomOut) zoomOut.style.display = 'none';
    var href = link.getAttribute('href');
    if (!href) return;
    var cleanHref = href.split('?')[0];
    fetch(cleanHref + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        /* Type label */
        if (p.type) {
          var label = document.createElement('span');
          label.className = 'cc-card-type';
          label.textContent = p.type;
          titleBlock.parentNode.insertBefore(label, titleBlock);
        }
        /* Ornament */
        var orn = document.createElement('div');
        orn.className = 'cc-card-ornament';
        orn.innerHTML = '<span class="cc-card-ornament-line"></span><span class="cc-card-ornament-diamond"></span><span class="cc-card-ornament-line"></span>';
        titleBlock.parentNode.insertBefore(orn, titleBlock);
        /* Subtitle — tag "subtitle:text" > first variant name > product type */
        var subtitle = '';
        if (p.tags) {
          for (var t = 0; t < p.tags.length; t++) {
            if (p.tags[t].toLowerCase().indexOf('subtitle:') === 0) {
              subtitle = p.tags[t].substring(9).trim();
              break;
            }
          }
        }
        if (!subtitle) {
          if (p.variants && p.variants.length > 0) {
            var v = p.variants[0];
            var vName = v.title !== 'Default Title' ? v.title : '';
            if (vName) subtitle = vName;
          }
        }
        if (!subtitle && p.type) subtitle = p.type;
        if (subtitle) {
          var varEl = document.createElement('span');
          varEl.className = 'cc-card-variant';
          varEl.textContent = subtitle;
          titleBlock.parentNode.insertBefore(varEl, titleBlock.nextSibling);
        }
        /* Add ring */
        var content = card.querySelector('.product-card__content');
        if (content && !card.querySelector('.cc-card-add-ring')) {
          var ring = document.createElement('button');
          ring.className = 'cc-card-add-ring';
          ring.setAttribute('aria-label', 'View product');
          ring.innerHTML = '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
          content.appendChild(ring);
        }
      })
      .catch(function() {});
  });
}

/* ── Merch PDP — no JS badge injection needed (handled by section) ── */
function ccInjectMerchBadges() {}

/* ── Klaviyo form submissions ── */
var CC_KLAVIYO_KEY = 'TwrX2c';

function ccKlaviyoSubmit(e, listId, prefix) {
  e.preventDefault();
  var btn = e.target.querySelector('button[type="submit"]');
  var origText = btn.innerHTML;
  btn.textContent = 'Sending…';

  var email = (document.getElementById(prefix + '-email') || e.target.querySelector('[name="email"]'))?.value;
  var firstName = (document.getElementById(prefix + '-first') || e.target.querySelector('[name="first_name"]'))?.value;
  var lastName = (document.getElementById(prefix + '-last') || e.target.querySelector('[name="last_name"]'))?.value;
  var phone = (document.getElementById(prefix + '-phone') || e.target.querySelector('[name="phone"]'))?.value;

  var props = {};
  e.target.querySelectorAll('input, select, textarea').forEach(function(inp) {
    if (inp.name && !['email','first_name','last_name','phone'].includes(inp.name)) {
      if (inp.type === 'checkbox') {
        if (inp.checked) {
          if (!props[inp.name]) props[inp.name] = [];
          props[inp.name].push(inp.value);
        }
      } else if (inp.value) {
        props[inp.name] = inp.value;
      }
    }
  });

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CC_KLAVIYO_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Website Form',
          profile: { data: { type: 'profile', attributes: { email: email, first_name: firstName || '', last_name: lastName || '', phone_number: phone || '', properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    })
  })
  .then(function(r) {
    if (r.ok || r.status === 202) {
      btn.innerHTML = 'Sent ✓';
      e.target.reset();
      setTimeout(function() { btn.innerHTML = origText; }, 3000);
    } else {
      btn.innerHTML = 'Error — try again';
      setTimeout(function() { btn.innerHTML = origText; }, 3000);
    }
  })
  .catch(function() {
    btn.innerHTML = 'Error — try again';
    setTimeout(function() { btn.innerHTML = origText; }, 3000);
  });
  return false;
}

function ccKlaviyoNewsletter(e, listId) {
  e.preventDefault();
  var btn = e.target.querySelector('button[type="submit"]');
  var origText = btn.innerHTML;
  btn.textContent = 'Sending…';
  var email = document.getElementById('cc-newsletter-email')?.value;
  var msgEl = document.getElementById('cc-newsletter-msg');

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CC_KLAVIYO_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Website Newsletter',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    })
  })
  .then(function(r) {
    if (r.ok || r.status === 202) {
      if (msgEl) msgEl.innerHTML = '<p style="color:var(--gold);font-family:EB Garamond,serif;font-style:italic;">Thank you! We\'ll notify you when the shop opens.</p>';
      btn.innerHTML = 'Subscribed ✓';
      e.target.reset();
    } else {
      btn.innerHTML = 'Error — try again';
      setTimeout(function() { btn.innerHTML = origText; }, 3000);
    }
  })
  .catch(function() {
    btn.innerHTML = 'Error — try again';
    setTimeout(function() { btn.innerHTML = origText; }, 3000);
  });
  return false;
}

/* QR tutorial anchor.
   The printed QR points to /tutorial → Shopify redirects to this product with
   ?tutorial=1 → scroll to the tutorial section. Also honours a plain #tutorial
   hash. Falls back to the .cc-tutorial-section class if the id is ever removed,
   so rewriting the tutorial section never breaks the QR. */
function ccTutorialScroll() {
  var params = new URLSearchParams(window.location.search);
  if (!params.has('tutorial') && window.location.hash !== '#tutorial') return;
  var done = false;
  function go() {
    if (done) return;
    var target = document.getElementById('tutorial') || document.querySelector('.cc-tutorial-section');
    if (!target) return;
    done = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (document.readyState === 'complete') {
    setTimeout(go, 200);
  } else {
    window.addEventListener('load', function() { setTimeout(go, 200); });
    /* Fallback if load is slow — attempt once after a max wait. */
    setTimeout(go, 1500);
  }
}

/* Menu card flip — homepage (.cc-menu-card) and Menu page (.cc-menu-pg-card).
   Click a card (or its "Learn more →" / "← Back" CTA, which bubble up) to flip.
   Only one card is open at a time — flipping one closes any other. */
function ccMenuFlip() {
  var cards = document.querySelectorAll('.cc-flip');
  if (!cards.length) return;
  cards.forEach(function(card) {
    card.addEventListener('click', function() {
      if (card.classList.contains('is-flipped')) {
        card.classList.remove('is-flipped');
      } else {
        document.querySelectorAll('.cc-flip.is-flipped').forEach(function(c) {
          c.classList.remove('is-flipped');
        });
        card.classList.add('is-flipped');
      }
    });
  });
}

/* Footer policy links — collapsible "Terms & Policies" toggle (mobile only;
   on desktop the toggle is hidden via CSS and the links show inline). */
function ccFooterPolicies() {
  var toggle = document.querySelector('.cc-foot-policies-toggle');
  if (!toggle) return;
  var wrap = toggle.closest('.cc-foot-policies');
  toggle.addEventListener('click', function() {
    var open = wrap.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { ccInit(); ccInjectProductType(); ccInjectMerchBadges(); ccTutorialScroll(); ccMenuFlip(); ccFooterPolicies(); });
} else {
  ccInit();
  ccInjectProductType();
  ccInjectMerchBadges();
  ccTutorialScroll();
  ccMenuFlip();
  ccFooterPolicies();
}
